/** MTMA diagnostics log event type codes from the device API. */
export enum MtmaDiagnosticsEventType {
  Error = 230,
  Info = 231,
}

/** Error event subtypes (Type 230). Gaps 12–19 are reserved / unused in API. */
export enum MtmaDiagnosticsErrorSubType {
  NoSimInserted = 1,
  SimLockedByPin = 2,
  WrongPinEntered = 3,
  SimLockedByPuk = 4,
  NoServiceAvailable = 5,
  NoApnStored = 6,
  WrongApn = 7,
  NoConfigurationStored = 8,
  NtpTimeError = 9,
  SslConnectionError = 10,
  MqttConnectionError = 11,
  AutoprovisioningFailed = 20,
  ProgrammingFailed = 21,
  UpdateFailed = 22,
  CallAccessEventsMemoryFull = 23,
}

/** Numeric subtypes for Type 230 (API); gaps 12–19 reserved. */
export const MTMA_DIAGNOSTICS_ERROR_SUBTYPE_VALUES: readonly number[] = [
  1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 20, 21, 22, 23,
];

/** Numeric subtypes for Type 231 (API). */
export const MTMA_DIAGNOSTICS_INFO_SUBTYPE_VALUES: readonly number[] = [
  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14,
];

/** Info event subtypes (Type 231). */
export enum MtmaDiagnosticsInfoSubType {
  GeneralState = 0,
  ResetCause = 1,
  FactoryDefaults = 2,
  NewOperator = 3,
  CurrentApnCleared = 4,
  NetModeChange = 5,
  NewSmsProcessed = 6,
  NewSmsDiscarded = 7,
  AutoprovisioningStarted = 8,
  AutoprovisioningCompleted = 9,
  ProgrammingStarted = 10,
  ProgrammingCompleted = 11,
  UpdateStarted = 12,
  UpdateCompleted = 13,
  UtcTimeRetrieved = 14,
}

export class MtmaDiagnosticsLog {
  Id?: number;
  DeviceUid: string;
  DeviceName: string;
  Type: number;
  SubType: number;
  Value: string;
  EventDate: Date;
  CreatedAt: Date;
}